module.exports = __webpack_public_path__ + "4795c928406eb2860e8913b4c3613767.jpg";